import * as yup from "yup";

export const validations = yup.object({
  category_name: yup.string().required("Wajib diisi"),
  status: yup.number().optional(),
});
